export default function SciPy_Intro() {
  return (
    <div>
      <h1>SciPy Intro</h1>
    </div>
  );
}
